import { NotificationFrequency } from "../types/Notifications";
import { type GiftCardEligibilityResponse } from "@/shared/utils/GiftCardUtils";

export class NotificationUtils {
    static isGiftCardEligible(promotionalOffer?: GiftCardEligibilityResponse): boolean {
        if (!promotionalOffer) return false;
        return promotionalOffer.eligible;
    }

    static shouldShowNotification(lastClosed: string | undefined, frequency: NotificationFrequency | undefined): boolean {
        if (!lastClosed) {
            return true;
        }

        if (!frequency) {
            return false;
        }

        const lastClosedDate = new Date(lastClosed);
        const now = new Date();
        const minutesToAdd = this.getMinutesToAdd(frequency);
        lastClosedDate.setMinutes(lastClosedDate.getMinutes() + minutesToAdd);

        return now >= lastClosedDate;
    }

    private static getMinutesToAdd(frequency: NotificationFrequency): number {
        switch (frequency) {
            case "hourly":
                return 60;
            case "daily":
                return 1440;
            case "weekly":
                return 10080;
            case "monthly":
                return 43800;
            case "yearly":
                return 525600;
            default:
                return 0;
        }
    }
}
